import axios from "axios";
const instance = axios.create({ baseURL: "https://mahalaxmi.ondemandcrm.co"}); //window.location.origin//
export default instance;
